var map = {
	"./ball-stroke-00.png": 648,
	"./ball-stroke-01.png": 649,
	"./ball-stroke-02.png": 650,
	"./ball-stroke-03.png": 651,
	"./ball-stroke-04.png": 652,
	"./ball-stroke-05.png": 653,
	"./ball-stroke-06.png": 654,
	"./ball-stroke-07.png": 655,
	"./ball-stroke-08.png": 656,
	"./ball-stroke-09.png": 657
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 279;